import type { components } from '../../api-types';
import { API_BASE_URL, apiClient } from './index';

export type AuthUser = components['schemas']['AuthUserDto'];

export const GOOGLE_SIGN_IN_URL = `${API_BASE_URL}/auth/google/start`;

export const getMe = async () => {
  const { data } = await apiClient.get<AuthUser>('/auth/me');
  return data;
};

export const logout = () => apiClient.post('/auth/logout');
